import axios from "axios";

const baseUrl = axios.create({
  // baseURL: "http://localhost:3000/api/",
  baseURL: "https://maintenancesystem.mosalam.com/api/",
  // baseURL: "https://maint-sys.onrender.com/api/",
  // timeout: 5000,
});

// baseUrl.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     console.log(error);
//     return Promise.reject(error);
//   }
// );

baseUrl.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      window.location.href = "/SignIn";
    }

    return Promise.reject(error);
  }
);

export default baseUrl;
